import { Box, Link, Typography } from '@mui/material';
import React from 'react';

const paragraphSx = {
    color: 'text.secondary',
    mb: 1.25,
    '@media print': {
        fontSize: '9px',
    },
};

const Disclaimer: React.FC = () => {
    return (
        <Box>
            <Typography
                variant="caption"
                sx={{
                    color: 'text.secondary',
                    display: 'block',
                    mb: 1,
                    '@media print': { fontSize: '11px' },
                }}
            >
                <strong>Disclaimer</strong>
            </Typography>
            <Typography variant="caption" sx={paragraphSx}>
                The publications on this portal have been prepared by Marex for
                information purposes only and are not intended (and should not
                be considered) to be legal advice on any subject matter. Marex
                does not give any representation or warranty, whether express or
                implied, as to the accuracy, completeness, currency or fitness
                for any purpose or use of any information on this portal or as
                to whether this portal reflects the current legislative or
                regulatory position or any other relevant developments. Marex
                assumes no responsibility to update the publications on this
                portal based on events after publication of the information
                contained therein.
            </Typography>
            <Typography variant="caption" sx={paragraphSx}>
                Readers are responsible for assessing the relevance and accuracy
                of the content of the information on this portal. Marex will not
                be liable for any loss, damage, cost or expense incurred or
                arising by reason of any person using or relying on information
                therein.
            </Typography>
            <Typography variant="caption" sx={paragraphSx}>
                Information on this portal should not be considered as advice,
                or as a recommendation or solicitation to purchase or otherwise
                deal in securities, investments or any other products. Such
                information has been prepared for institutional clients, is not
                directed at retail customers and does not take into account
                particular investment objectives, risk appetites, financial
                situations or needs. Recipients of the document should make
                their own trading or investment decisions based upon their own
                financial objectives and financial resources.
                <br />
                The publications on this portal constitute 'Marketing
                Communications' as defined in Directive 2014/65/EU of the
                European Parliament and the Council ("MiFID II") and Commission
                Delegated Directive (EU) 2017/593 ("MiFID Org Regulation"). The
                publications on this portal are not intended as investment
                research. The publications have not been prepared in accordance
                with the legal requirements designed to promote the independence
                of investment research, and are not subject to any regulatory
                prohibition on dealing ahead of the dissemination of investment
                research. Marex does not make any representations as to the
                monetary value of the publications. For further information,
                please contact:{' '}
                <Link href="mailto://MIFID-MIFIR@marex.com">
                    MIFID-MIFIR@marex.com
                </Link>
                . For important information concerning the contents and usage of
                these publications, please read the{' '}
                <Link
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.marex.com/cdd-disclaimer/"
                >
                    CDD Disclaimer
                </Link>
                .
            </Typography>
            <Typography variant="caption" sx={paragraphSx}>
                The Marex ® group of companies includes Marex Financial
                (including the Marex Solutions division), Marex Spectron
                International Limited, CSC Commodities UK Limited, Tangent
                Trading Limited, Marex Spectron Europe Limited, Marex North
                America LLC, Marex Capital Markets Inc., Marex Derivative
                Products Inc., Marex Spectron USA LLC, Spectron Energy Inc.,
                Marex Australia Pty Ltd, Marex MENA Limited, Marex Hong Kong
                Limited, Marex HK Asia Limited, Marex Spectron Asia Pte. Ltd.,
                Spectron Energy (Asia) Pte. Ltd., Marex France SAS (including
                the BIP AM division), X-Change Financial Access, LLC, Starsupply
                Petroleum Europe B.V., Volcap Trading Partners Limited, Volcap
                Trading Partners France SAS, Arfinco S.A and HPC SA (including
                its subsidiaries and branches), OTCex Hong Kong Limited and
                OTCex LLC (individually and collectively “Marex”).
            </Typography>
            <Typography variant="caption" sx={paragraphSx}>
                The information on this portal was approved by Marex Financial
                (“MF”). MF is incorporated under the laws of England and Wales
                (company no. 5613061, LEI no. 5493003EETVWYSIJ5A20 and VAT
                registration no. GB 872 8106 13) and is authorised and regulated
                by the Financial Conduct Authority (FCA registration number
                442767). MF’s registered address is at 155 Bishopsgate, London,
                EC2M 3TQ.
            </Typography>
        </Box>
    );
};

export default Disclaimer;
